import React from 'react';
import earthSvg from '../../assets/icons/earth-outline.svg?raw';
import { svgInner } from './svgInner';

const EARTH = svgInner(earthSvg);

/**
 * Ionicons earth-outline — Global Produce Map sidebar icon.
 *
 * Drawn from the icon file rather than a copy of its path data. The file
 * carries its own fills and stroke (one outlined path, five filled), so it is
 * inlined as exported; the wrapper only supplies size and the viewBox.
 */
export const GlobalProduceMap = ({ size = 20, className = '', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    fill="none"
    className={className}
    aria-hidden="true"
    dangerouslySetInnerHTML={{ __html: EARTH }}
    {...props}
  />
);
